import { postJSON } from "apis/apiHelpers.js";
import { getAuthToken } from "selectors/appSelector.js";
import store from "store.js";

// Tags the confirmed buyplan when find_or_create_buyplan has resolved one,
// falling back to the release in the brief window before it resolves (or if
// it genuinely fails), same fallback TabsList.jsx used for the now-removed
// release.visual_summary_tab.selected tracking. brandId is a last-resort
// fallback for BrandLayout's QuickFill routes (/brands/:brandId/products),
// which have no :releaseId segment at all — without it, Search/Report/etc.
// on QuickFill resolve nothing server-side whenever the qfill buyplan
// (lazily created on page load) hasn't landed in Redux yet.
export const buyplanOrReleaseRecord = (confirmedBuyplanId, releaseId, brandId) => {
  if (confirmedBuyplanId) return { record_type: "buyplan", record_id: confirmedBuyplanId };
  if (releaseId) return { record_type: "release", record_id: releaseId };
  return { record_type: "brand", record_id: brandId };
};

// Classifies which kind of "buyplan-like" workflow a product action happened
// in. smType (selectors/buyplanInfoSelector.js) takes precedence: a CnF/
// SuperFill page has no buyplan_id at all (StockModel isn't a Buyplan), so
// buyplanState there is either absent or a leftover template placeholder,
// not a meaningful value. Quick Fill is a real Buyplan row (state "qfill",
// selectors/buyplanIdSelector.js) worth distinguishing from a regular one;
// every other state (buyplan, template, order, consignment, ...) falls back
// to the generic "Buyplan" label.
export const buyplanTypeLabel = (buyplanState, smType) => {
  if (smType === "superfill") return "Superfill";
  if (smType === "cnf") return "CnF";
  if (buyplanState === "qfill") return "Quickfill";
  return "Buyplan";
};

// Shared buyplan_id/buyplan_type pair for range_page_action call sites,
// mirroring the same stockModalId-wins-over-buyplanId logic already used for
// product_card_action/quick_view_action (see Thumbnail.jsx, Quantity.jsx,
// etc.) — buyplan_id is never populated on a CnF/SuperFill page (StockModel
// isn't a Buyplan), so the StockModel's own id goes there instead, and
// buyplan_type labels which of the two (or Quickfill/plain Buyplan) it is.
export const buyplanContext = (buyplanId, stockModalId, buyplanState, smType) => ({
  buyplan_id: stockModalId || buyplanId,
  buyplan_type: buyplanTypeLabel(buyplanState, smType)
});

// Fire-and-forget analytics tracking. Deliberately does not go through the
// app's usual POST_DATA saga/action/reducer flow (see postDataSaga.js) —
// that machinery exists for calls whose success/failure updates UI state,
// which tracking never does. Must fail silently from the user's
// perspective; only logs to the console in development.
export const trackAnalyticsEvent = (eventName, context = {}) => {
  const apiToken = getAuthToken(store.getState());

  postJSON("/api/analytics_events", apiToken, undefined, {
    payload: { event_name: eventName, ...context }
  }).catch(error => {
    // eslint-disable-next-line no-undef
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.error("Analytics tracking failed:", error);
    }
  });
};
